'use strict';

import { GenericTableData } from 'Lib/data';

// User Module Event Bus. Handles all interactions with Users.
let UserData = GenericTableData.getTableDataBus('USER', 'users');

UserData.populateUsers = async () => {
  UserData.getAllRecords({ fields: 'full_name,status,username' }).then(
    (results) => {
      let fullUserList = results?.records || [];
      UserData.notifyListeners('ALL_USERS_LOADED', fullUserList);
      return fullUserList;
    },
  );
};

UserData.createUser = (recordData) => {
  return UserData.createRecord(recordData).then((results) => {
    UserData.populateUsers();
    return results;
  });
};

export default UserData;
